import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field"]
  static values = { message: String }

  connect() {
    this.fieldTargets.forEach((field) => {
      field.addEventListener("input", this.#clearValidation)
    })
  }

  disconnect() {
    this.fieldTargets.forEach((field) => {
      field.removeEventListener("input", this.#clearValidation)
    })
  }

  validate(event) {
    this.#clearValidation()
    if (this.#hasAnyValue()) return

    const field = this.fieldTargets[0]
    field.setCustomValidity(this.messageValue)
    field.reportValidity()
    event.preventDefault()
    event.stopImmediatePropagation()
  }

  #hasAnyValue() {
    return this.fieldTargets.some((field) => !field.disabled && field.value.trim().length > 0)
  }

  #clearValidation = () => {
    this.fieldTargets.forEach((field) => field.setCustomValidity(""))
  }
}
